<div class="create_intake_sec" [class.blur-content]="util.isDialogOpen$()">
  <!-- Content -->
  <div class="no_data_intake">
    <div class="nodata_content">No courses & instances available</div>
    <div class="nodata_content_1">Get started by creating your first course & instance</div>
    <button roleAccessControl accessType="create" #actionAccessControl="accessControl" class="custom_btn" mat-stroked-button color="primary" (click)="openCourseType()">
      <span class="material-icons">add</span>CREATE NEW
    </button>
    @if (!actionAccessControl.accessControl) {
      <button class="custom_btn course_dis_btn" mat-stroked-button color="primary">
        <span class="material-icons">add</span>CREATE NEW
      </button>
    }
  </div>
  <!-- Main-Content -->

  <!--Content -->
</div>


